<template>
    <div>
        <v-data-table :headers="headers"
                      :header-props="{ sortIcon: null }"
                      :items="data"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      item-key="id"
                      show-expand
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                      class="elevation-1"
                      :loading="loading"
                      @page-count="pageCount = $event"
                      :options.sync="innerOptions"
                      :server-items-length="totalPages">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                </v-toolbar>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <detailsMembre class="ma-4" :membre="item"></detailsMembre>
                </td>
            </template>
        </v-data-table>
        <div class="text-center pt-2">
            <v-pagination v-model="page"
                          :length="pageCount"></v-pagination>
        </div>
    </div>
</template>

<script>
    import detailsMembre from '../../components/detailsMembre'

    export default {
        props: ["headers", "data", "itemsPerPage", "singleExpand", "loading", "title", "totalPages"],
        components: {
            detailsMembre
        },
        data() {
            return {
                expanded: [],
                page: 1,
                pageCount: 0,
                innerOptions: {}
            }
        },
        watch: {
            innerOptions: {
                handler(value) {
                    this.$emit("refreshOptions", value);
                },
                deep: true,
            },
        }
    }
</script>

<!-- Faire attention, ce CSS n'est pas scoped -->
<style>
    tr.v-data-table__expanded.v-data-table__expanded__row {
        background-color: #c0c0c05c;
        border: 2px solid silver;
    }
</style>